import { Box } from '@mui/material'
import ProgramPageHero from '../programs/ProgramPageHero'
import ProgramIntroSection from '../programs/ProgramIntroSection'
import ProgramWhySection from '../programs/ProgramWhySection'
import ProgramSkillsSection from '../programs/ProgramSkillsSection'
import ProgramStatsSection from '../programs/ProgramStatsSection'
import ProgramOtherInitiativesSection from '../programs/ProgramOtherInitiativesSection'
import ProgramGallerySection from '../programs/ProgramGallerySection'
import ProgramMissionSection from '../programs/ProgramMissionSection'
import ProgramTestimonialsSection from '../programs/ProgramTestimonialsSection'
import { homeTestimonials } from '../../data/homeContent'
import BulletListSection from './BulletListSection'
import { programSectionWrapperSx, programInnerSx, programSectionGap } from '../programs/programLayout'
import { mobileSectionPy } from '../../theme/mobileLayout'

export default function ProgramPageTemplate({ data }) {
  if (!data) return null

  const introParagraphs = data.introParagraphs ?? (data.intro ? [data.intro] : [])
  const introImage = data.introImage ?? data.heroImage

  return (
    <Box>
      <Box
        sx={{
          ...programSectionWrapperSx,
          pt: { ...mobileSectionPy, md: '120px', lg: '260px' },
          pb: mobileSectionPy,
        }}
      >
        <ProgramPageHero
          title={data.title}
          subtitle={data.subtitle}
          cta={data.cta}
          ctaLink={data.ctaLink}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: programSectionGap,
          pb: { xs: 8, md: 12, lg: '150px' },
        }}
      >
        <Box sx={programSectionWrapperSx}>
          <Box
            sx={{
              ...programInnerSx,
              display: 'flex',
              flexDirection: 'column',
              gap: programSectionGap,
            }}
          >
            {(introImage || introParagraphs.length > 0) && (
            <ProgramIntroSection
              image={introImage}
              imageAlt={data.title}
              paragraphs={introParagraphs}
              imageCrop={data.introImageCrop}
            />
          )}

          {data.mission && (
            <ProgramMissionSection title={data.missionTitle} text={data.mission} />
          )}

          {data.whyTitle && data.whyItems?.length > 0 &&
            (data.useProgramWhyLayout || data.whyStarIcon ? (
              <ProgramWhySection
                title={data.whyTitle}
                items={data.whyItems}
                starSrc={data.whyStarIcon}
                titleMaxWidth={data.whyTitleMaxWidth}
              />
            ) : (
              <BulletListSection title={data.whyTitle} items={data.whyItems} sx={{ mb: 0 }} />
            ))}

            {data.skills?.length > 0 && (
              <ProgramSkillsSection
                title={data.skillsTitle}
                skills={data.skills}
                layout={data.skillsLayout ?? 'grid'}
              />
            )}

            {data.stats?.length > 0 && (
              <ProgramStatsSection title={data.statsTitle} stats={data.stats} />
            )}
          </Box>
        </Box>

        {data.showOtherInitiatives && (
          <ProgramOtherInitiativesSection excludePath={data.excludeFromInitiatives} />
        )}

        {data.galleryImages?.length > 0 && (
          <Box sx={programSectionWrapperSx}>
            <Box sx={programInnerSx}>
              <ProgramGallerySection title={data.galleryTitle} images={data.galleryImages} />
            </Box>
          </Box>
        )}
      </Box>

      {data.showExperiences && (
        <ProgramTestimonialsSection testimonials={data.testimonials ?? homeTestimonials} />
      )}
    </Box>
  )
}
